import stylesheet0 from "@oneappexchange/appx-grid";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".categories" + shadowSelector + " {padding-top: var(--sds-g-spacing-2);}.category" + shadowSelector + " {padding-right: var(--sds-g-spacing-2);padding-bottom: var(--sds-g-spacing-2);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];